<template>
    <div class="flex error-page">
        <div class="w-full text-gray-200">
            <div class="text-center">
                <div class="text-5xl md:text-15xl">{{$t(title)}}</div>
                <p class="text-2xl md:text-3xl font-light mb-8 leading-normal">{{$t(message)}}</p>
                <a
                    :href="route('terminal.lobby')"
                    class="bg-transparent text-grey-200 font-bold uppercase py-3 px-6 border-2 border-grey-200 hover:border-grey-400 rounded-lg">
                    {{$t('Back To Lobby')}}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    props: {
        title: String,
        message: String,
    },
    methods: {
        listenOnKey(e) {
            if(e.key === ' ') {
                this.$inertia.visit(this.route('terminal.lobby'));
            }
        }
    },
    created() {
        window.addEventListener('keydown', this.listenOnKey);
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.listenOnKey);
    }
}
</script>

<style lang="scss" scoped>
.error-page {
    height: calc(100vh - 64px) ;
}
</style>
